<p-dialog
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [modal]="true"
  [draggable]="false"
  [closable]="true"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [appendTo]="'body'"
  [style]="{ width: 'min(64rem, 96vw)' }"
  styleClass="bn-account-detail-dialog"
>
  <ng-template #header>
    <div class="bn-account-detail__heading">
      <div class="bn-account-detail__title-row">
        <h2 id="bn-account-detail-title" class="bn-account-detail__title">
          {{ title() }}
        </h2>
        @if (status()) {
          <p-tag
            [value]="status()"
            [severity]="statusSeverity(status())"
            [rounded]="true"
            styleClass="bn-accounts-status"
          />
        }
      </div>
      @if (subline()) {
        <p class="bn-account-detail__subline">{{ subline() }}</p>
      }
      @if (detailsCollapsed() && compactMetrics().length) {
        <div
          class="bn-account-detail__compact"
          data-testid="account-detail-compact"
        >
          @for (metric of compactMetrics(); track metric.label) {
            <div class="bn-account-detail__compact-item">
              <span class="bn-account-detail__compact-label">{{
                metric.label
              }}</span>
              <span class="bn-account-detail__compact-value">{{
                metric.value
              }}</span>
            </div>
          }
        </div>
      }
    </div>
  </ng-template>

  <bds-scroll-region
    maxHeight="min(75vh, 52rem)"
    styleClass="bn-account-detail__scroll"
    ariaLabel="Account details"
  >
    <div class="bn-account-detail__body">
      @if (store.loading()) {
        <div
          class="bn-account-detail__skeleton"
          data-testid="account-detail-skeleton"
          role="status"
          aria-label="Loading account details"
        >
          <p-skeleton width="8rem" height="0.7rem" />
          <p-skeleton width="7rem" height="1.75rem" />
          <p-skeleton width="10rem" height="1.25rem" />
        </div>
      } @else if (store.error()) {
        <div
          class="bn-account-detail__error"
          role="alert"
          data-testid="account-detail-error"
        >
          <p>We couldn't load this account right now.</p>
          <p-button
            label="Retry"
            severity="secondary"
            size="small"
            (onClick)="retry()"
          />
        </div>
      } @else if (spending(); as summary) {
        <div #detailsSentinel class="bn-account-detail__summary">
          <bn-spending-summary [summary]="summary" />
        </div>
        @if (showTransactions()) {
          <div class="bn-account-detail__ledger">
            <bn-account-transactions
              [guid]="data().guid"
              [accountId]="data().id"
              [accountType]="data().inventoryType"
            />
          </div>
        }
      } @else if (savings(); as summary) {
        <div #detailsSentinel class="bn-account-detail__summary">
          <div class="bn-account-detail__stack">
            <bn-account-summary-metrics
              [metrics]="summary.metrics"
              [columns]="4"
            />
            <bn-linked-accounts-list [section]="summary.linkedAccounts" />
          </div>
        </div>
        @if (showTransactions()) {
          <div class="bn-account-detail__ledger">
            <bn-account-transactions
              [guid]="data().guid"
              [accountId]="data().id"
              [accountType]="data().inventoryType"
            />
          </div>
        }
      } @else if (debt(); as metrics) {
        <div #detailsSentinel class="bn-account-detail__summary">
          <bn-account-summary-metrics [metrics]="metrics" [columns]="2" />
        </div>
        @if (showTransactions()) {
          <div class="bn-account-detail__ledger">
            <bn-account-transactions
              [guid]="data().guid"
              [accountId]="data().id"
              [accountType]="data().inventoryType"
            />
          </div>
        }
      } @else if (loan(); as metrics) {
        <div #detailsSentinel class="bn-account-detail__summary">
          <bn-account-summary-metrics [metrics]="metrics" [columns]="4" />
        </div>
        @if (showTransactions()) {
          <div class="bn-account-detail__ledger">
            <bn-account-transactions
              [guid]="data().guid"
              [accountId]="data().id"
              [accountType]="data().inventoryType"
            />
          </div>
        }
      } @else if (store.payload()) {
        <div
          #detailsSentinel
          class="bn-account-detail__summary"
          data-testid="account-detail-generic"
        >
          <p>Additional details aren't available for this account type.</p>
        </div>
      }
    </div>
  </bds-scroll-region>
</p-dialog>
